var _rect, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGrantDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 105,
    viewBox: "0 0 64 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 105,
    rx: 2,
    fill: "#001236"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1724_27082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.334 38H22.834V48.8333H35.334V38Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6673 42.1667H35.334V48.8334H41.1673V44.6667L38.6673 42.1667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5833 52.9999C27.7339 52.9999 28.6667 52.0672 28.6667 50.9166C28.6667 49.766 27.7339 48.8333 26.5833 48.8333C25.4327 48.8333 24.5 49.766 24.5 50.9166C24.5 52.0672 25.4327 52.9999 26.5833 52.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4173 52.9999C38.5679 52.9999 39.5007 52.0672 39.5007 50.9166C39.5007 49.766 38.5679 48.8333 37.4173 48.8333C36.2667 48.8333 35.334 49.766 35.334 50.9166C35.334 52.0672 36.2667 52.9999 37.4173 52.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.764 60.38H12.326V58.91H9.778V57.118H7.93V58.91H5.312V60.38H7.93V60.828C7.93 62.76 6.964 64.944 4.878 65.91L5.872 67.324C7.314 66.68 8.308 65.378 8.868 63.838C9.4 65.266 10.338 66.47 11.71 67.1L12.69 65.7C10.674 64.734 9.764 62.648 9.764 60.828V60.38ZM17.072 61.822H15.196V56.824H13.348V69.704H15.196V63.348H17.072V61.822ZM18.4429 60.072V64.048H19.5489C22.1249 64.048 23.7629 63.992 25.5549 63.656L25.4009 62.172C23.7909 62.466 22.3769 62.55 20.2769 62.564V61.444H24.3089V57.566H18.4289V59.05H22.4889V60.072H18.4429ZM23.8889 68.304C22.2089 68.304 21.3409 67.982 21.3409 67.268C21.3409 66.554 22.2089 66.232 23.8889 66.232C25.5689 66.232 26.4369 66.554 26.4369 67.268C26.4369 67.982 25.5689 68.304 23.8889 68.304ZM23.8889 64.818C21.2009 64.818 19.5209 65.714 19.5209 67.268C19.5209 68.808 21.2009 69.718 23.8889 69.718C26.5769 69.718 28.2569 68.808 28.2569 67.268C28.2569 65.714 26.5769 64.818 23.8889 64.818ZM29.8389 60.044V58.546H28.1309V56.81H26.2829V64.58H28.1309V62.76H29.8389V61.262H28.1309V60.044H29.8389ZM44.7417 56.824H42.8797V66.078H44.7417V56.824ZM36.0197 60.912C36.0197 59.848 36.7757 59.232 37.7277 59.232C38.6937 59.232 39.4217 59.848 39.4217 60.912C39.4217 61.948 38.6937 62.578 37.7277 62.578C36.7757 62.578 36.0197 61.948 36.0197 60.912ZM41.2277 60.912C41.2277 59.008 39.7017 57.636 37.7277 57.636C35.7537 57.636 34.2137 59.008 34.2137 60.912C34.2137 62.788 35.7537 64.174 37.7277 64.174C39.7017 64.174 41.2277 62.788 41.2277 60.912ZM38.0077 68.01V65.168H36.1597V69.48H45.0637V68.01H38.0077ZM53.6586 66.736V64.048H57.3406V62.564H50.1306V59.176H57.2426V57.692H48.2686V64.048H51.8106V66.736H46.9106V68.248H58.5866V66.736H53.6586Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1724_27082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 35.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrantDelivery);
export default __webpack_public_path__ + "static/media/icon_grant_delivery.03d415123fb9f220b215eb921615aea0.svg";
export { ForwardRef as ReactComponent };